import React, { useState } from 'react';
import ServiceDiagram, { DIAGRAMS } from '../ServiceDiagram';

const SERVICES = [
  {
    name: 'Web and mobile development',
    description: 'Custom web platforms and Flutter apps, from the first prototype to the production release.',
    diagram: 'development',
  },
  {
    name: 'Cloud solutions',
    description: 'Infrastructure that holds up under load and stays affordable when it does. We set it up and we keep it running.',
    diagram: 'cloud',
  },
  {
    name: 'Digital transformation',
    description: 'We work out which business processes should move to software first, then build and roll them out with your team.',
    diagram: 'transformation',
  },
  {
    name: 'IT consulting',
    description: 'An outside view on architecture, security and cost from engineers who build these systems every day.',
    diagram: 'consulting',
  },
];

const Services = () => {
  const [active, setActive] = useState(0);
  const { diagram } = SERVICES[active];

  return (
    <section id="services" className="services" aria-labelledby="services-title">
      <div className="services-intro">
        <h2 id="services-title">One team, from the screen down to the servers.</h2>
      </div>
      <div className="services-layout">
        <ul className="service-list">
          {SERVICES.map((service, index) => (
            <li key={service.name} className={index === active ? 'is-active' : ''}>
              <button
                type="button"
                aria-pressed={index === active}
                onClick={() => setActive(index)}
              >
                <span className="service-heading">
                  <span className="service-name">{service.name}</span>
                  <span className="service-toggle" aria-hidden="true" />
                </span>
                <span className="service-description"><span>{service.description}</span></span>
              </button>
            </li>
          ))}
        </ul>
        <figure className="services-map">
          <ServiceDiagram diagram={diagram} />
          <figcaption>{DIAGRAMS[diagram].caption}</figcaption>
        </figure>
      </div>
    </section>
  );
};

export default Services;
